import {Injectable} from '@angular/core';
import io from 'socket.io-client';
import {Observable} from 'rxjs';
import {SettingsService} from './settings.service';
import {StorageService} from './storage.service';


@Injectable()
export class WebsocketService {
  apiUrl: string;
  socket: any;

  constructor(private settings: SettingsService, private storage: StorageService) {
    this.apiUrl = this.settings.apiUrl;
    const websocketHost = location.host.indexOf('localhost') !== -1 ? 'localhost:3000' : this.settings.apiUrl.replace('https://', '').replace('/api', '');
    this.socket = io(websocketHost);
  }

  emit(e, par) {
    this.socket.emit(e, par);
  }

  public removeAll() {
    this.socket.removeAllListeners();
  }

  public new_event(clientID): Observable<[]> {
    return new Observable<[]>(observer => {
      this.socket.on('create_event-today-' + clientID, (data) => {
        observer.next(data);
      });
    });
  }

  public new_message(clientID): Observable<[]> {
    return new Observable<[]>(observer => {
      this.socket.on('create_message-' + clientID, (data) => {
        observer.next(data);
      });
    });
  }

  public new_file(chatID): Observable<[]> {
    return new Observable<[]>(observer => {
      this.socket.on('upload_attach-' + chatID, (data) => {
        observer.next(data);
      });
    });
  }

  public update_message(chatID): Observable<[]> {
    return new Observable<[]>(observer => {
      this.socket.on('update_message-' + chatID, (data) => {
        observer.next(data);
      });
    });
  }

  public newTravelEvent(): Observable<[]> {
    const clientID = this.storage.userId;
    return new Observable<[]>(observer => {
      this.socket.on('new_travel_' + clientID, (data) => {
        observer.next(data);
      });
    });
  }

  public newEvent(): Observable<[]> {
    const clientID = this.storage.userId;
    return new Observable<[]>(observer => {
      this.socket.on('travel_event_' + clientID, (data) => {
        observer.next(data);
      });
    });
  }

}
